import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import reactCSS from 'reactcss';
import { Popover } from '@material-ui/core';

const ColorPicker = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { onChange, color, height, width } = props;

    const onClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const onClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'color-popover' : undefined;

    const styles = reactCSS({
        default: {
            color: {
                width: `${width || '100%'}`,
                height: `${height || '30px'}`,
                borderRadius: '3px',
                background: `${color}`
            },
            swatch: {
                width: `${width || '100%'}`, //'100%',
                padding: '6px',
                background: '#ffffff',
                borderRadius: '2px',
                cursor: 'pointer',
                display: 'inline-block',
                boxShadow: '0 0 0 1px rgba(0,0,0,.2)'
            }
        }
    });

    return (
        <div>
            <div style={styles.swatch} onClick={onClick}>
                <div style={styles.color} />
            </div>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={onClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <SketchPicker color={color || '#000000'} onChange={onChange} />
            </Popover>
        </div>
    );
};

export default ColorPicker;
